export const PORTFOLIO_TYPE = {
  ModelPortfolio: { key: 'ModelPortfolio', value: 'Model' },
  FundOfFunds: { key: 'FundOfFunds', value: 'Fund of funds' },
  SelfSelect: { key: 'SelfSelect', value: 'Self select' },
  None: { key: 'None', value: 'None' }
} as const
